import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTagBasedSharingRestriction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.69045 19.5795H4.72371C3.73819 19.5795 2.79303 19.1879 2.09617 18.4911C1.3993 17.7942 1.00781 16.8491 1.00781 15.8636V12.9745C1.00781 9.79859 2.2694 6.75288 4.51505 4.50724C6.7607 2.26159 9.80643 1 12.9823 1H14.0135C14.9989 1 15.9442 1.39149 16.641 2.08836C17.3378 2.78523 17.7294 3.73037 17.7294 4.71589V9.76942",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 13.1324C1 8.33889 6.10939 12.2033 9.10994 9.19345C12.1105 6.18363 8.27386 1 13.0581 1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIconTagBasedSharingRestriction;
